import angular from 'angular';
import uiRouter from 'angular-ui-router';
import passwordFormElementComponent from './passwordFormElement.component';

let passwordFormElementModule = angular.module('passwordFormElement', [
  uiRouter
])

.component('passwordFormElement', passwordFormElementComponent)

.name;

export default passwordFormElementModule;
